import React from "react";
import "./popover.scss";
import classnames from "classnames";

interface Props {
    children: React.ReactNode;
    title:any;
    position: any;
  }
  
  const PopOver: React.FC<Props> = ({
    children,
    title,
    position,
    ...rest
  }) => {
    return (

        <div className={classnames("popoverMenu ") +  (position)}>
            <h3>{title}</h3> 
            <div className="popoverContent">
              {children}
            </div>
        </div>
        );
    };
    
    export default PopOver;
      